import { useEffect, useState } from "react";
import { IconButton } from "@narmi/design_system";
import { useInstitution } from "byzantine/src/dbbl/businessLogic/entities";
import styles from "./BalancesPlusDropdown.module.scss";

export default function BalancesPlusDropdown() {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const institution = useInstitution();
  const entryPoints = institution?.account_opening_entry_points_config?.balances_dropdown ?? [];

  // dismiss the dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownOpen && !(event.target as HTMLElement).closest(`.${styles.plus_dropdown_container}`)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [dropdownOpen]);

  if (!entryPoints || entryPoints.length === 0) {
    return null; // No entry points to display
  }

  // We want to ensure that you can tab onto the dropdown options when the dropdown is open.

  return (
    <div className={styles.plus_dropdown_container}>
      {dropdownOpen && (
        <div className={styles.dropdown}>
          <span className="fontWeight--semibold margin--left--m margin--top--m">
            Open an account
          </span>
          <hr className={styles.title_divider}/>
          <div style={{ display: "flex", flexDirection: "column", gap: "0px"}}>
            {entryPoints.map((entryPoint) => (
              <a
                key={entryPoint.target}
                className={styles.dropdown_select_item}
                aria-label={`Open ${entryPoint.name} account`}
                tabIndex={0}
                href={`/v1/entry_points?platform=${entryPoint.platform}&selected=${encodeURIComponent(entryPoint.target)}`}
              >
                {entryPoint.name}
              </a>
            ))}
          </div>
        </div>
      )}
      <IconButton
        kind="plain"
        name="plus"
        textSize="m"
        className={styles.plus_button}
        aria-label="Open account dropdown"
        onClick={() => { setDropdownOpen(!dropdownOpen); }}
      />
    </div>
  );
}
